// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5209":"168b708a24ee6f14","5236":"1bed925bb1de2195"}[chunkId] + ".js";
};